var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "standout" },
    [
      _c("div", { staticClass: "standout__title" }, [
        _vm.item.country
          ? _c("img", {
              staticClass: "standout__flag",
              attrs: {
                width: "24",
                src: _vm.item.country.local,
                alt: _vm.item.country.name,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h3", {
          staticClass: "standout__client",
          domProps: { textContent: _vm._s(_vm.item.client) },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "standout__date",
          domProps: { textContent: _vm._s(_vm.item.date) },
        }),
      ]),
      _vm._v(" "),
      _vm.item.counterpart
        ? _c("span", {
            staticClass: "standout__counterpart",
            domProps: { textContent: _vm._s(_vm.item.counterpart) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("DataList", {
        attrs: {
          items: [
            {
              title: "Deal Type",
              value: _vm.item.deal_type,
              icon: "deal",
              isSector: false,
            },
            {
              title: "Implied EV ($m)",
              value: _vm.item.implied_ev,
              icon: "value",
              isSector: false,
            },
            {
              title: "Main Sector",
              value: _vm.item.sector,
              isSector: true,
            },
          ],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }